import { useContext } from 'react';
import { DocumentSettingsContext } from '../../DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import { PageSetupView } from '../../DocumentSettings/DocumentDesignSettings/PageSetupView';
import MarginSettings from '../../DocumentSettings/DocumentDesignSettings/margin/MarginSettings';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { FeatureFlags } from 'utils/featureFlags';
import PageOrientationSelect from '../../DocumentSettings/PageOrientationSelect';

export function PageSetupSettings() {
  const { documentSettings, updateBackgroundColor, updatePageOrientation, commitBackgroundColor, captureDocumentSettings } =
    useContext(DocumentSettingsContext);
  const evaluateFeatureFlag = useFeatureFlag([FeatureFlags.pageOrientationSettings]);
  const isPageOrientationEnabled = evaluateFeatureFlag[FeatureFlags.pageOrientationSettings];

  return (
    <PageSetupView
      backgroundColor={documentSettings.backgroundColor}
      onColorChange={updateBackgroundColor}
      onOpen={captureDocumentSettings}
      onClose={(color) => commitBackgroundColor && commitBackgroundColor(color)}
      orientationSlot={
        isPageOrientationEnabled ? (
          <PageOrientationSelect value={documentSettings.pageOrientation ?? 'portrait'} onChange={updatePageOrientation} />
        ) : undefined
      }
      marginsSlot={<MarginSettings />}
    />
  );
}
